import React, { Fragment, useContext, useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import { Alert, Card, Button, Form } from "react-bootstrap"

import Constants from '../../config.js'
import { UserContext } from "../../Contexts/UserContext/UserContext.js";
import useLog from '../../hooks/useLog.js';
import { Loader } from '../../components/Loader.js';

import CardStyled from "../../components/CardStyled.js"
import "../../resources/css/global.css"
import "./create_new_wallet.css"
import { ButtonPrimary, ButtonPrimaryOutlined } from '../../components/Buttons.js';



const Create_New_Wallet = (props) => {

    const function_id = "Create_New_Wallet(): "
    const classname = function_id
    const log = useLog(function_id)

    const userContext = useContext(UserContext)

    const [currSeed, set_currSeed] = useState(null)

    const [askedCreateNewWallet, set_askedCreateNewWallet] = useState(false)


    /** 14.12.2021 - TODO WE NEED TO FIND A BETTER SOLUTION FOR THIS
     * Especially we MUST NOT BUILD A FILE DISK CACHE AT THIS STAGE
     * but we should let it for later, after confirming the password & clicking "next"
     * then we will display a popup to load the wallet & do all the extensive stuff
    */

    async function onClick_newSeed() {
        /*  we don't actually ask for a new seed to be generated here, we only reset everything
            as if this component just loaded, and a new seed will be generated automatically
            (this method avoids conflicts) */
        log("onClick_newSeed()")
        await userContext.reset_wallet()  // will set mnemonic="" && privkey_owner=""
        set_currSeed(null)  // reset to display loader
        set_askedCreateNewWallet(false)
    }

    // if(!currSeed){
    //     if(userContext.mnemonic){
    //         set_currSeed(userContext.mnemonic)
    //     }
    //     else {
    //         // give a bit of time to not freeze display
    //         setTimeout(()=>{
    //             userContext.create_new_wallet()
    //         }, 500)
    //     }
    // }

    // case when we need to ask for a new seed to be generated
    if (!currSeed && !userContext.mnemonic && !askedCreateNewWallet) {
        set_askedCreateNewWallet(true)
        // give a bit of time to not freeze display
        setTimeout(() => {
            userContext.create_new_wallet()
        }, 500)
    }

    // case where a new seed has been generated and we need to display it
    if (userContext.mnemonic && userContext.mnemonic !== currSeed) {
        set_currSeed(userContext.mnemonic)
    }

    const readyForNewSeedButton = !!userContext.create_new_wallet_ready && !!currSeed

    log(
        "\n !!userContext.mnemonic =", !!userContext.mnemonic,  // don't print mnemonic !
        "\n !!currSeed =", !!currSeed,
        "\n !!askedCreateNewWallet =", !!askedCreateNewWallet,
        "\n readyForNewSeedButton =", readyForNewSeedButton,
    )

    var show_message = <center>
        Generating new wallet... <Loader small />
    </center>

    if (currSeed) {
        show_message =
            // <TextCopyQR value={context.mnemonic} />
            <div style={{
                padding: "15px", textAlign: "center", border: "1px solid red",
                wordSpacing: "0.8em", lineHeight: "2.5em"
            }}>
                {currSeed}
            </div>
    }

    // this style is used to deactivate some buttons while generating the seed
    var newSeedButton_style = {}
    if (!readyForNewSeedButton) {
        newSeedButton_style = {
            pointerEvents: "none",
            backgroundColor: "gray",
        }
    }

    useEffect(() => {  // on mount
        userContext.update_newpassword_previous("create_new_wallet")
    })

    return (
        <div className="slide" style={{  // make it easier to scroll if needed 
            overflowY: "scroll",
            height: "97vh",
        }}>
            <h2>
                &nbsp; {Constants.CREATE_WALLET_TITLE}<br />
            </h2> <br />

            <CardStyled title={Constants.WALLET_INFO}>
                <Alert variant="danger" style={{ fontWeight: "bold", fontSize: "18px" }}>
                    <i className="fa fa-info-circle" style={{ fontSize: "20px" }} /> &nbsp;
                    {Constants.SEED_INFO}
                </Alert>
                <Alert variant="danger" style={{ fontWeight: "bold", fontSize: "18px" }}>
                    <i className="fa fa-info-circle" style={{ fontSize: "20px" }} /> &nbsp;
                    {Constants.SEED_INFO_MORE}
                </Alert>
                <Card.Title style={{
                    border: "1px solid #cce1ffa6",
                    backgroundColor: "#2082b952",
                    borderRadius: "6px",
                }}>
                    {show_message}
                </Card.Title>
            </CardStyled>
            <br />

            {/* {readyForNewSeedButton ?
                <div style={{ width: "100%", textAlign: "center" }}>
                    <div className="new_seed_button" onClick={onClick_newSeed}
                        style={{ ...newSeedButton_style }} >
                        Generate another phrase
                    </div>
                    <br />
                </div>
                : null} */}

            {/* Buttons */}

            <div className="bottom-buttons">
                <div className="return-button">
                    <NavLink className="return-logo" to="/select_wallet">
                        <ButtonPrimaryOutlined>
                            Back
                        </ButtonPrimaryOutlined>
                    </NavLink>
                </div>
                <div className="next-button">
                    <NavLink className="return-logo" to={readyForNewSeedButton ? "/enter_wallet_name" : "#"}>
                        <ButtonPrimary style={newSeedButton_style}>
                            Continue
                        </ButtonPrimary>
                    </NavLink>
                </div>
            </div>

            {/* make it easier to scroll if needed */}
            <div style={{ height: "40vh" }}>&nbsp;</div>

        </div >
    )
}

export default Create_New_Wallet
